import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

const postTwoFactorAuth = async ({ endpoint, payload }) => {
  const response = await new FnrFetch3(endpoint, payload).post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

const postUpdateName = async ({ userID, fullName, changeOriginParams }) => {
  const endpoint = `/user/${userID}/updateName`;

  const response = await new FnrFetch3(endpoint, {
    fullName,
    userID,
    ...changeOriginParams,
  })
    .post()
    .catch((err) =>
      fnThrowError({
        message: `Error at ${endpoint}: ${err}`,
      })
    );

  return response;
};

export { postTwoFactorAuth, postUpdateName };
